function Upload_form_element(element) {
    this.$element = $(element);

    this.selectors = {
	    containerStatus: '.js-container-status',
	    statusText: '.js-status-text',
	    buttonUpload: '.js-button-upload',
	    buttonCancel: '.js-button-cancel',
	    imagePreview: '.js-image-preview',
	    linkPreview: '.js-link-preview',
	    hiddenUploadedFile: '.js-hidden-uploaded-file'
    };

    this.data = {
	    pluginName: 'plugin-name',
	    extension: 'extension',
	    httpRelative: 'http-relative'
    };

    this.modifiers = {
	    hover: 'f-upload--hover'
    };

    this.init = function() {
		  // console.log('Upload_form_element this.$element', this.$element);

	    this.$containerStatus = this.$element.find(this.selectors.containerStatus);
	    this.$statusText = this.$element.find(this.selectors.statusText);
	    this.$buttonUpload = this.$element.find(this.selectors.buttonUpload);
	    this.$buttonCancel = this.$element.find(this.selectors.buttonCancel);
	    this.$imagePreview = this.$element.find(this.selectors.imagePreview);
	    this.$linkPreview = this.$element.find(this.selectors.linkPreview);
	    this.$hiddenUploadedFile = this.$element.find(this.selectors.hiddenUploadedFile);

	    this.dataPluginName = this.$element.data(this.data.pluginName);
	    this.dataExtension = this.$element.data(this.data.extension);
		  this.dataHttpRelative = this.$element.data(this.data.httpRelative);

		  this.$buttonCancel.on('click', this.$onClickCancel.bind(this));
		  this.$buttonUpload.on('click', this.$onClickUpload.bind(this));

	    this.$imagePreview.hide();
      this.$linkPreview.hide();
      this.$containerStatus.hide();

      this.initDropzone();
    };

	this.initDropzone = function() {

		this.myDropzone = new Dropzone(this.$element[0], {
			url: i4_Ajax.ajax_file+'&js=filemanager&call=upload_file&plugin='+this.dataPluginName,
			paramName: 'file',
			acceptedFiles: this.dataExtension.map(item => '.'+item).join(', '),
			previewsContainer: false,
			clickable: this.$buttonUpload[0]
		});

		this.myDropzone.on('sending', (file) => {
			// console.log('sending', file);
			this.$containerStatus.show();
			this.$imagePreview.hide();
			this.$linkPreview.hide();
			this.$buttonUpload.hide();
			this.$hiddenUploadedFile.attr('value', '');
			this.$imagePreview.attr('src', '');
			this.$linkPreview.attr('href', '');
		});

		this.myDropzone.on('uploadprogress', (file) => {
			// console.log('uploadprogress', file);
			// console.log('progress', file.upload.progress);
			this.$statusText.text(Math.floor(file.upload.progress)+'%');
		});

		this.myDropzone.on('error', (file) => {
			// console.log('error', file);
		});

		this.myDropzone.on('success', (file) => {
			// console.log('success', file);
		});

		this.myDropzone.on('complete', (file) => {
			// console.log('complete', file);

			if (file.status === 'success') {

				const responseJSON = file.xhr !== '' && JSON.parse(file.xhr.responseText);
				// console.log('responseJSON', responseJSON);

				if (responseJSON.success) {

					if (responseJSON.type === 'image') {
						// image
						this.$imagePreview.attr('src',this.dataHttpRelative+responseJSON.tn_url);
						this.$hiddenUploadedFile.attr('value', responseJSON.fm_id);
						this.$imagePreview.show();
            this.$hiddenUploadedFile.trigger('i4:upload-complete-image');
					} else {
						// document
						this.$linkPreview.attr('href', this.dataHttpRelative+responseJSON.doc_url);
						this.$hiddenUploadedFile.attr('value', responseJSON.fm_id);
						this.$linkPreview.show();
            this.$hiddenUploadedFile.trigger('i4:upload-complete');
					}

					this.$containerStatus.hide();
					this.$buttonUpload.show();

          this.$element.trigger('i4:change');
				}

			} else if (file.status === 'canceled') {
				this.$containerStatus.hide();
				this.$buttonUpload.show();
			} else {
				// todo: show error (eg. wrong file extension)

				console.warn('uploading file was not successfull', file);
			}
		});

		this.myDropzone.on('dragenter', () => {
			// console.log('dragenter');
			this.$element.addClass(this.modifiers.hover);
		});

		this.myDropzone.on('dragleave', () => {
			// console.log('dragleave');
			this.$element.removeClass(this.modifiers.hover);
		});

		this.myDropzone.on('drop', () => {
			this.$element.removeClass(this.modifiers.hover);
		});

	};

	this.$onClickCancel = function() {
		this.myDropzone.removeAllFiles(true);
	};

	this.$onClickUpload = function(e) {
		e.preventDefault();
	};

}
